export const safeNavigate = (rawUrl: string): void => {
    if (typeof window === 'undefined') return
  
    try {
      const url = new URL(rawUrl, window.location.origin)
      if (url.protocol !== 'http:' && url.protocol !== 'https:') return
      window.location.href = url.toString()
    } catch {
      // Invalid URL - silently ignore
    }
  }